module.exports = __webpack_public_path__ + "static/media/pink-bubble-arrow.1e96b92c.svg";